import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { IApplyDependenciesResult } from '../interfaces';

@Injectable({
    providedIn: 'root'
})
export class SubjectsService {
    private dependenciesAppliedSubject = new BehaviorSubject<IApplyDependenciesResult | null>(null);
    private dependenciesAppliedObservable = this.dependenciesAppliedSubject.asObservable();

    getDependenciesAppliedSubject(): BehaviorSubject<IApplyDependenciesResult | null> {
        return this.dependenciesAppliedSubject;
    }

    getDependenciesAppliedObservable(): Observable<IApplyDependenciesResult | null> {
        return this.dependenciesAppliedObservable;
    }
}
